export var NAME_MAX_CHARS = 20;
export var DESCRIPTION_MAX_CHARS = 85;
export var GET_IMAGE_ROUTE = function (path) { return "https://static.wixstatic.com/" + path; };
//# sourceMappingURL=index.js.map